import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { verifyClicToPayPayment } from "../services/payments";
import "./Payment.css";

export default function PaymentStatus() {
  const { accessToken } = useAuth();
  const { search } = useLocation();
  const [result, setResult] = useState({ state: "loading", message: "Confirming your payment..." });

  useEffect(() => {
    const params = new URLSearchParams(search);
    const orderId = params.get("orderId") || params.get("order_id");
    if (!orderId) {
      setResult({ state: "failure", message: "We could not identify this payment transaction." });
      return;
    }

    let cancelled = false;
    verifyClicToPayPayment(accessToken, orderId)
      .then((response) => {
        if (cancelled) return;
        if (response.payment?.status === "completed" && response.orderStatus === 2) {
          setResult({ state: "success", message: "Your payment was successful. Your lesson pack is now available." });
        } else if (response.payment?.status === "pending") {
          setResult({ state: "pending", message: "Your payment is still being confirmed. Please refresh this page shortly." });
        } else {
          setResult({ state: "failure", message: "Your payment was not completed. No access has been granted." });
        }
      })
      .catch(() => {
        if (!cancelled) setResult({ state: "failure", message: "We could not verify your payment. Please try again or contact support." });
      });

    return () => {
      cancelled = true;
    };
  }, [accessToken, search]);

  const heading = result.state === "success" ? "Payment successful" : result.state === "pending" ? "Payment pending" : result.state === "loading" ? "Confirming payment" : "Payment failed";
  return (
    <main className="payment-page">
      <section className={`payment-panel payment-status payment-status--${result.state}`} aria-live="polite">
        <span className="payment-status__icon" aria-hidden="true">{result.state === "success" ? "OK" : result.state === "failure" ? "!" : "..."}</span>
        <h1>{heading}</h1>
        <p>{result.message}</p>
        {result.state !== "loading" ? <Link className="btn primary" to="/courses">Return to lesson packs</Link> : null}
      </section>
    </main>
  );
}